export const VERSIONS_TABLE_COLUMNS_SIZES = {
  VERSION: 10,
  STATUS: 12,
  UPDATED: 32,
  DESCRIPTION: 46,
};
